import { Download, ExpandLess, ExpandMore } from "@mui/icons-material";
import { Button, Collapse, Grid, Table, TableBody, TableCell, TableHead, TableRow, Card, LinearProgress, Tooltip } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { SnackbarActions } from "../../../redux/actions/snackbar.actions";
import { axiosFetch } from "../../../utils/AxiosFetch";
import { hasChildren } from "../PMP/TeamPerformance/TeamUtils";
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { PeriodList } from '../../../utils/PeriodList';
import Select from "react-select";
import { loadTrainingStatus } from '../../../redux/actions/lookups.action'
import EmployeeTrainingList from "./EmployeeTrainingList";
import * as XLSX from 'xlsx';
import excel from '../../../assets/excel.png'
import GroupIcon from '@mui/icons-material/Group';
import { padding } from "@mui/system";


export default function TeamTrainingHierarchy() {
    const [teamList, setTeamList] = useState([]);
    const [period, setPeriod] = useState("");
    const [status, setStatus] = useState(null);
    const [statusOption, setStatusOption] = useState([]);
    const [periodOption, setPeriodOption] = useState([]);
    const [year, setYear] = useState(null);
    const [session, setSession] = useState(null);
    const [statusId, setStatusId] = useState(null);
    const [loading, setLoading] = useState(true);
    const [modalOpen, setModalOpen] = useState(false);
    const [empTraining, setEmpTraining] = useState([]);
    const [name, setName] = useState("")
    let LUTrainingStatus = useSelector((state) => state.loadTrainingStatus_Reducer.trainingStatus);



    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        dispatch(loadTrainingStatus())
        getCurrentSessionDetails()
        getOptions()
    }, [])

    useEffect(() => {
        if (LUTrainingStatus.length > 0) {
            setStatusOption(LUTrainingStatus)
        }
    }, [LUTrainingStatus])

    
    function getCurrentSessionDetails() {
        const currentYear = new Date().getFullYear();
        const currentMonth = new Date().getMonth() + 1;
        var value = null;
        if (currentMonth <= 6) {
            value = {
                lable: currentYear + "-" + 'H1',
                value: currentYear + "-" + 'H1'
            }

        }
        else {
            value = {
                lable: currentYear + "-" + 'H2',
                value: currentYear + "-" + 'H2'
            }

        }
        var list = PeriodList(3, "half");

        const res = list.filter(list => list.value === value.value)[0];
        setPeriod(res);
        var date = res.value;
        var yearValue = date.split("-")[0];
        var dateValue = date.split("-")[1];
        setYear(yearValue);
        setSession(dateValue);
        console.log(yearValue,dateValue)
        fetchList(yearValue,dateValue)

    }

    const fetchList = (getYear,getSession) => {
        var req = {
            "id": null,
            "year": getYear,
            "session": getSession,
            "statusId": statusId
        }
        console.log(req);
        loadTeamList(req)
    }

    const loadTeamList = (req) => {
        axiosFetch({
            method: "post",
            url: `/training/list/team`,
            requestConfig: req
        })
            .then((res) => {
                if (res.status === 200) {
                    setTeamList(res.data);
                } else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
                else if (res.status === 401) {
                    navigate('/');
                }
            })
    }

    const handleClear = () => {
        // setPeriod("");
        getCurrentSessionDetails();
        setYear(null);
        setSession(null);
        setStatus(null);
        setStatusId(null);
        // loadTeamList()
    }
    const handlePeriod = (selected) => {
        setPeriod(selected)
        var value = selected.value;
        if(value !== "all"){
            var yearValue = value.split("-")[0];
            var dateValue = value.split("-")[1];
            setYear(yearValue);
            setSession(dateValue);
        }
        else{
            setYear(null);
        setSession(null);
        }
        
    }

    const handleStatus = (selected) => {
        setStatus(selected);
        setStatusId(parseInt(selected.value));
    }

    const handleSearch = () => {
        fetchList(year,session);
    }
    const handleView = (userId, statusId,name) => {
        setName(name)
        axiosFetch({
            method: "post",
            url: `/training/users`,
            requestConfig: {
                "id": parseInt(userId),
                "statusId": parseInt(statusId),
                "year": year,
                "session": session,
            }
        })
            .then((res) => {
                if (res.status === 200) {
                    handleModal()
                    setEmpTraining(res.data);
                } else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
                else if (res.status === 401) {
                    navigate('/');
                }
            })
    }

    const handleModal = () => {
        if(modalOpen){
            setModalOpen(false)
        }
        else{
            setModalOpen(true)
        }
    }

    const exportData = (param,id,name) => {
        var req;
        if (param === 1) {
            req = {
                "session": session,
                "year": year
            }
        }
        else if (param === 2) {
            req = {
                "userId": id,
                "session": session,
                "year": year
            }
        }
        else if (param === 3) {
            req = {
                "managerId": id,
                "session": session,
                "year": year
            }
        }
        else{
            req = {
                "session": session,
                "year": year
            }
        }
        axiosFetch({
            method: "post",
            url: `/training/users/download`,
            requestConfig: req
        })
            .then((res) => {
                if (res.status === 200) {
                    downloadData(res.data,param,name);
                } else if (res.status === 400) {
                    dispatch(SnackbarActions(true, "error", "Something Went Wrong!"));
                }
                else if (res.status === 401) {
                    navigate('/');
                }
            })
    }

    const downloadData = (result,type,name) => {
        var fileName = "AllTrainings";
        if(type === 2){
            fileName = name
        }
        else if(type === 3){
            fileName = name+'\'s Team'
        }
        else{
            fileName = "AllTrainings";
        }
        var scheduledData = result.filter(data => data.statusId === 2);
        var ongoingData = result.filter(data => data.statusId === 3);
        var completeData = result.filter(data => data.statusId === 4);
        const complete = completeData.map(({ id, topicId, attendees, statusId, statusName, actualFileName, durationHours, empStatusId, empStatusName, employeeId, employeeLevelId, employeeTrainingLevel, externalTrainerName, externalTrainingType, firstName, isActive, lastName, physicalFileName, sessionId, skillSet, userId, referenceUrl, trainingType, trainingLevelId,createrName, ...rest }) => {
            return rest;
        });
        const scheduled = scheduledData.map(({ id, topicId, attendees, statusId, statusName, actualFileName, durationHours, empStatusId, empStatusName, employeeId, employeeLevelId, employeeTrainingLevel, externalTrainerName, externalTrainingType, firstName, isActive, lastName, physicalFileName, sessionId, skillSet, userId, referenceUrl, trainingType, trainingLevelId,createrName, ...rest }) => {
            return rest;
        });
        const ongoing = ongoingData.map(({ id, topicId, attendees, statusId, statusName, actualFileName, durationHours, empStatusId, empStatusName, employeeId, employeeLevelId, employeeTrainingLevel, externalTrainerName, externalTrainingType, firstName, isActive, lastName, physicalFileName, sessionId, skillSet, userId, referenceUrl, trainingType, trainingLevelId,createrName, ...rest }) => {
            return rest;
        });
        console.log(complete)
        let header = ["Training Type", "Training Level", "Trainer Comments", "Manager Comments ", "Employee Name", "Employee Number", "Department Name", "Team Name", "Reporting Manager", "Reference url", "Title", "Description", "Start Date", "End Date", "Training Name", "Slots"];
        var wb = XLSX.utils.book_new();
        var wsCompleted = XLSX.utils.json_to_sheet(complete);
        XLSX.utils.sheet_add_aoa(wsCompleted, [header]);
        XLSX.utils.book_append_sheet(wb, wsCompleted, "Completed");

        var wsScheduled = XLSX.utils.json_to_sheet(scheduled);
        XLSX.utils.sheet_add_aoa(wsScheduled, [header]);
        XLSX.utils.book_append_sheet(wb, wsScheduled, "Scheduled");

        var wsOngoing = XLSX.utils.json_to_sheet(ongoing);
        XLSX.utils.sheet_add_aoa(wsOngoing, [header]);
        XLSX.utils.book_append_sheet(wb, wsOngoing, "On Going");

        XLSX.writeFileXLSX(wb, `${fileName}.xlsx`);
    }


    const getOptions = () => {
        const opt = PeriodList(2, "half");
        var allOpt = {label: "All",value: "all"};
        opt.push(allOpt)
        setPeriodOption(opt)
    }
    return (
        <div>
            <Card sx={{ padding: 1, margin: 2, paddingBottom :2 }}>
                <h3 className="filter-heading">Filters</h3>

                <Grid container spacing={2}>
                    <Grid item xs={4}>
                        <Select placeholder={<div>Select period</div>}
                            menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            options={periodOption}
                            value={period}
                            onChange={handlePeriod}
                        />
                    </Grid>
                    <Grid item xs={4}>
                        <Select placeholder={<div>Select Status</div>}
                            menuPortalTarget={document.body} menuPosition={'fixed'} styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            options={statusOption}
                            value={status}
                            onChange={handleStatus}
                        />
                    </Grid>
                    <Grid item xs={4} >
                        <Button className="theme-btn cancel-btn" sx={{ float: "none", marginRight: "10px" }} variant="contained"
                            onClick={() => handleClear()}>
                            Clear
                        </Button>
                        <Button className="theme-btn" sx={{ float: "none", marginRight: "10px" }} variant="contained"
                            onClick={() => handleSearch()}>
                            Search
                        </Button>
                        <Tooltip  title="Click to download report"><Button className="theme-btn all-down" sx={{ float: "none", marginRight: "10px" }} variant="contained" onClick={() => exportData(1)}>  <img src={excel} alt="icon"/>  Export</Button></Tooltip>
                    </Grid>
                </Grid>
            </Card>
           

            <Table className="tt-bg">
                <TableHead >
                    <TableRow className="team-traing-bg">
                        <TableCell></TableCell>
                        <TableCell>Name</TableCell>
                        <TableCell>On Going</TableCell>
                        <TableCell>Completed</TableCell>
                        <TableCell>Scheduled</TableCell>
                        <TableCell>Action</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {teamList.map((item, key) => <MenuItem key={key} item={item} handleView={handleView} exportData={exportData} />)}

                </TableBody>
            </Table>
            <EmployeeTrainingList open={modalOpen} modal={handleModal} data={empTraining} empName={name}/>
        </div>
    )
}

const MenuItem = ({ item,handleView, exportData }) => {
    const MenuComponent = hasChildren(item) ? MultiLevel : SingleLevel;
    return <MenuComponent item={item} handleView={handleView} exportData={exportData} />
};



const SingleLevel = ({ item, handleView, exportData }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
   

    
    return (
        <TableRow >
            <TableCell  className="team-arrow"/>
            <TableCell className="team-txt-nme" >
            <p style={{cursor:"pointer"}} onClick={()=>navigate(`/users-profile/${item.id}`)}> {item.employeeName}</p>
            </TableCell>
            <TableCell className="team-txt-ongo">
                {item.onGoing ? <p style={{cursor:"pointer",textDecoration: 'underline'}} onClick={() => handleView(item.id, 3,item.employeeName)}>{item.onGoing}</p> : "-"}
            </TableCell>
            <TableCell className="team-txt-cmpt">{item.completed ? <p style={{cursor:"pointer",textDecoration: 'underline'}} onClick={() => handleView(item.id, 4,item.employeeName)}>{item.completed}</p> : "-"}</TableCell>
            <TableCell className="team-txt-schd">{item.scheduled ? <p style={{cursor:"pointer",textDecoration: 'underline'}} onClick={() => handleView(item.id, 2,item.employeeName)}>{item.scheduled}</p> : "-"}</TableCell>
            <TableCell> 
            <Tooltip title="Click to download individual report" arrow  placement="left"><Button className="indu-view" startIcon={<Download fontSize="small"/>} disabled={item.onGoing === null && item.completed === null && item.scheduled === null}  onClick={() => exportData(2,item.id,item.employeeName)}>  Report</Button></Tooltip>

                </TableCell>    
        </TableRow>
    );
};

const MultiLevel = ({ item,handleView, exportData }) => {

    const { members: children } = item;
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
   


    const handleClick = () => {
        setOpen((prev) => !prev);
    };

   

    return (
        <React.Fragment>
            {/* <TableRow> */}

            <TableRow className= {open ? 'team-lt-name team-training-line':''}  >
                <TableCell className="team-arrow">
                    {open ? <ExpandMore onClick={handleClick} /> : <KeyboardArrowRightIcon onClick={handleClick} />}
                </TableCell>
                <TableCell className="team-txt-nme" ><p style={{cursor:"pointer"}} onClick={()=>navigate(`/users-profile/${item.id}`)}> {item.employeeName}</p></TableCell>
                <TableCell className="team-txt-ongo">{item.onGoing ? <p style={{cursor:"pointer",textDecoration: 'underline'}} onClick={() => handleView(item.id, 3,item.employeeName)}>{item.onGoing}</p> : "-"}</TableCell>
                <TableCell className="team-txt-cmpt">{item.completed ? <p style={{cursor:"pointer",textDecoration: 'underline'}} onClick={() => handleView(item.id, 4,item.employeeName)}>{item.completed}</p> : "-"}</TableCell>
                <TableCell className="team-txt-schd">{item.scheduled ? <p style={{cursor:"pointer",textDecoration: 'underline'}} onClick={() => handleView(item.id, 2,item.employeeName)}>{item.scheduled}</p> : "-"}</TableCell>
                <TableCell> 
               <span> 
               <Tooltip  title="Click to download individual report" arrow  placement="left"><Button className="indu-view"  startIcon={<Download fontSize="small"/>} disabled={item.onGoing === null && item.completed === null && item.scheduled === null} onClick={() => exportData(2,item.id, item.employeeName)}>  Report</Button></Tooltip> </span>
                </TableCell> 
            </TableRow>
            {open ?
                <TableRow>
                    <TableCell colSpan={6}>
                    <div className='lead-tm' >Team of {item.employeeName} 
                    <Tooltip  title="Click to download team report" arrow  placement="left"><Button className="team-view"  startIcon={<GroupIcon fontSize="small"/>} onClick={() => exportData(3,item.id, item.employeeName)}>  Teams Report </Button></Tooltip></div>
                        <Collapse in={open} timeout="auto" unmountOnExit className='team-training-line'>
                            <Table className="inner-tm-line">
                                {children.map((child, key) => (
                                    <MenuItem key={key} item={child} handleView={handleView}  exportData={exportData}/>
                                ))}
                            </Table>
                        </Collapse>
                    </TableCell>
                </TableRow>
                : ''}
        </React.Fragment>
    );
};
